/* eslint-disable react/jsx-wrap-multilines */
import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import 'react-responsive-modal/styles.css';

import PageWrapper from './components/wrappers/PageWrapper';
import ProtectedRoute from './components/wrappers/ProtectedRoute';
import AdminProtectedRoute from './components/wrappers/AdminProtectedRoute';
import ErrorBoundary from './components/common/ErrorBoundary';
import PageLoader from './components/common/PageLoader';

import Index from './pages/home/Index';
import AboutUs from './pages/about/Index';
import Signin from './pages/signin/Index';
import GetStarted from './pages/signin/GetStarted';
import Programmes from './pages/Programmes';
import Gallery from './pages/gallery/Index';
import NotFound from './pages/not-found';
import BankingSchool from './pages/schools/BankingSchool';
import BitSchool from './pages/schools/BitSchool';
import BusinessSchool from './pages/schools/BusinessSchool';
import CultureSchool from './pages/schools/CultureSchool';
import LeadershipSchool from './pages/schools/LeadershipSchool';
import SmeSchool from './pages/schools/SmeSchool';

const Dashboard = lazy(() => import('./pages/dashboard/Index'));
const Tasks = lazy(() => import('./pages/tasks/Index'));
const Profile = lazy(() => import('./pages/profile'));
const MyLearning = lazy(() => import('./pages/my-learning'));
const TrainingRequest = lazy(() => import('./pages/training-request'));
const NewRequest = lazy(() => import('./pages/training-request/new-request'));
const LineManagerQueue = lazy(() => import('./pages/line-manager'));
const Admin = lazy(() => import('./pages/admin'));
const Queue = lazy(() => import('./pages/admin/queue'));
const AdminLogin = lazy(() => import('./pages/admin-portal/Login'));
const AdminOverview = lazy(() => import('./pages/admin-portal/Overview'));
const AdminRequests = lazy(() => import('./pages/admin-portal/Requests'));
const AdminRequestDetail = lazy(() => import('./pages/admin-portal/RequestDetail'));

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<PageWrapper />}>
              <Route path="/" element={<Index />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/programs" element={<Programmes />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/school/banking" element={<BankingSchool />} />
              <Route path="/school/bit" element={<BitSchool />} />
              <Route path="/school/business" element={<BusinessSchool />} />
              <Route path="/school/culture" element={<CultureSchool />} />
              <Route path="/school/leadership" element={<LeadershipSchool />} />
              <Route path="/school/sme" element={<SmeSchool />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/sign-in" element={<Signin />} />
            <Route path="/get-started" element={<GetStarted />} />

            <Route path="/admin-portal/login" element={<AdminLogin />} />

            <Route element={<AdminProtectedRoute />}>
              <Route path="/admin-portal" element={<AdminOverview />} />
              <Route path="/admin-portal/overview" element={<AdminOverview />} />
              <Route path="/admin-portal/requests" element={<AdminRequests />} />
              <Route path="/admin-portal/requests/:requestRef" element={<AdminRequestDetail />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/my-learning" element={<MyLearning />} />
              <Route path="/training-request" element={<TrainingRequest />} />

              <Route element={<PageWrapper />}>
                <Route path="/new-request" element={<NewRequest />} />
                <Route path="/line-manager" element={<LineManagerQueue />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/queue" element={<Queue />} />
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
